var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _rect9, _rect0, _rect1, _line2, _rect10, _rect11, _rect12, _rect13, _line3, _rect14, _rect15, _rect16, _line4, _rect17, _rect18, _rect19, _rect20, _line5, _rect21, _rect22, _rect23, _line6, _rect24, _rect25, _rect26, _line7, _rect27, _rect28, _rect29, _line8, _rect30, _rect31, _rect32, _line9, _rect33, _rect34, _rect35, _line0, _line1, _line10, _line11, _text, _text2, _text3, _text4, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _text5, _g, _text6, _rect45, _polyline, _rect46, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderHelper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352.98 449.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #00b3b5;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        stroke: #a7a9ac;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        fill: #00b3b5;\n      }\n\n      .cls-8 {\n        fill: #333;\n      }\n\n      .cls-9 {\n        fill: #a7a9ac;\n      }\n\n      .cls-6 {\n        font-family: GothamBlack-Italic, 'Gotham Black';\n        font-size: 16px;\n        font-style: italic;\n      }\n\n      .cls-7 {\n        font-family: GothamBlack, 'Gotham Black';\n        font-size: 12px;\n      }\n\n      .cls-4 {\n        stroke: #666969;\n        stroke-width: 2px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 35.26,
    y: 34.26,
    width: 85.64,
    height: 37.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 81.06,
    width: 41.36,
    height: 5.64
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 90.25,
    width: 41.36,
    height: 5.64
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 99.44,
    width: 41.36,
    height: 5.64
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 119.33,
    y: 106.49,
    width: 117.15,
    height: 13.11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 118.05,
    y: 176.11,
    width: 30,
    height: 7.98
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 159.78,
    y: 176.11,
    width: 30,
    height: 7.98
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 201.51,
    y: 176.11,
    width: 30,
    height: 7.98
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 192.59,
    x2: 280.13,
    y2: 192.59
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 200.11,
    width: 68.98,
    height: 7.98
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 200.11,
    width: 30,
    height: 7.98
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 200.11,
    width: 30,
    height: 7.98
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 216.59,
    x2: 280.13,
    y2: 216.59
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 224.11,
    width: 68.98,
    height: 7.98
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 224.11,
    width: 30,
    height: 7.98
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 224.11,
    width: 30,
    height: 7.98
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 159.75,
    y: 224.11,
    width: 30,
    height: 7.98
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 240.59,
    x2: 280.13,
    y2: 240.59
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 248.11,
    width: 68.98,
    height: 7.98
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 248.11,
    width: 30,
    height: 7.98
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 248.11,
    width: 30,
    height: 7.98
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 264.59,
    x2: 280.13,
    y2: 264.59
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 272.11,
    width: 68.98,
    height: 7.98
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 272.11,
    width: 30,
    height: 7.98
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 272.11,
    width: 30,
    height: 7.98
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 160.75,
    y: 272.11,
    width: 30,
    height: 7.98
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 288.59,
    x2: 280.13,
    y2: 288.59
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 296.11,
    width: 68.98,
    height: 7.98
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 296.11,
    width: 30,
    height: 7.98
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 296.11,
    width: 30,
    height: 7.98
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 312.59,
    x2: 280.13,
    y2: 312.59
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 320.11,
    width: 68.98,
    height: 7.98
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 320.11,
    width: 30,
    height: 7.98
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 320.11,
    width: 30,
    height: 7.98
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 336.59,
    x2: 280.13,
    y2: 336.59
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 344.11,
    width: 68.98,
    height: 7.98
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 344.11,
    width: 30,
    height: 7.98
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 344.11,
    width: 30,
    height: 7.98
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 360.59,
    x2: 280.13,
    y2: 360.59
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 368.11,
    width: 68.98,
    height: 7.98
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 368.11,
    width: 30,
    height: 7.98
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 368.11,
    width: 30,
    height: 7.98
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.08,
    y1: 384.59,
    x2: 280.13,
    y2: 384.59
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 36.32,
    y: 392.11,
    width: 68.98,
    height: 7.98
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 118.05,
    y: 392.11,
    width: 30,
    height: 7.98
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 201.51,
    y: 392.11,
    width: 30,
    height: 7.98
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 111.82,
    y1: 173.65,
    x2: 111.82,
    y2: 409.47
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 153.82,
    y1: 173.65,
    x2: 153.82,
    y2: 409.47
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 195.82,
    y1: 173.65,
    x2: 195.82,
    y2: 409.47
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 237.82,
    y1: 173.65,
    x2: 237.82,
    y2: 409.47
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(70.35 164.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(129.25 164.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(171.88 164.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(212.09 164.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 243.51,
    y: 176.11,
    width: 30,
    height: 7.98
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 200.11,
    width: 30,
    height: 7.98
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 224.11,
    width: 30,
    height: 7.98
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 248.11,
    width: 30,
    height: 7.98
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 272.11,
    width: 30,
    height: 7.98
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 296.11,
    width: 30,
    height: 7.98
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 320.11,
    width: 30,
    height: 7.98
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 344.11,
    width: 30,
    height: 7.98
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 243.51,
    y: 392.11,
    width: 30,
    height: 7.98
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(254.45 164.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m290.27,76.66h41.04l-59.48-57.51v39.07c0,10.17,8.27,18.44,18.44,18.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m259.83,58.22V12.06H30.44c-10.17,0-18.44,8.27-18.44,18.44v388.36c0,10.17,8.27,18.44,18.44,18.44h292.08c10.17,0,18.44-8.27,18.44-18.44V88.66h-50.69c-16.78,0-30.44-13.65-30.44-30.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m269.29,0h-9.46v.06H30.44C13.65.06,0,13.72,0,30.5v388.36c0,16.78,13.65,30.44,30.44,30.44h292.08c16.78,0,30.44-13.65,30.44-30.44V88.66h.02v-7.74L269.29,0Zm2.54,19.15l59.48,57.51h-41.04c-10.17,0-18.44-8.27-18.44-18.44V19.15Zm69.13,399.71c0,10.17-8.27,18.44-18.44,18.44H30.44c-10.17,0-18.44-8.27-18.44-18.44V30.5c0-10.17,8.27-18.44,18.44-18.44h229.39v46.16c0,16.78,13.65,30.44,30.44,30.44h50.69v330.2Z"
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(41.39 183.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Header"))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 167.51,
    y: 131.85,
    width: 16.49,
    height: 16.49
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "180.28 136.94 175.37 143.6 165.9 126.77"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 248.51,
    y: 131.85,
    width: 16.49,
    height: 16.49
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "261.28 136.94 256.37 143.6 246.9 126.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderHelper);
export default __webpack_public_path__ + "static/media/header-helper.96c1260965cc2012e5671e21764354ec.svg";
export { ForwardRef as ReactComponent };